import { render } from "./AiChat.vue?vue&type=template&id=56ac13d6"
import script from "./AiChat.vue?vue&type=script&lang=js"
export * from "./AiChat.vue?vue&type=script&lang=js"

import "./AiChat.vue?vue&type=style&index=0&id=56ac13d6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__